module.exports = __webpack_public_path__ + "img/tth.8e74b462.jpg";